<template>
  <div>
    <slot v-bind:open="open"/>
    <Modal :show="show" @closeModal="close" size="md">
      <h2 class="text-lg absolute left-5 top-5 font-bold">Add Item</h2>
      <div class="mt-8 py-6">
      <div class="mb-3" v-if="error">
        <div class="bg-red-200 text-red-500 text-center p-3">{{ error }}</div>
      </div>
        <div class="grid grid-cols-2 gap-4">
          <div class="col-span-full">
            <label for="shop" class="pb-2">Free Item</label>
            <v-select id="shop"
                      v-model="form.free_item"
                      :options="selectableItems"
                      :filterable="false"
                      @option:selected="reloadItemUnits"
                      label="item_code"
                      :reduce="reduceOption"
                      class="tailwind-v-select tailwind-v-select-menu w-full"
                      @search="searchItemCodes"
            >
              <template slot="option" slot-scope="option">
                <div class="flex flex-col">
                  <p class="text-base text-gray-800">{{ option.description }}</p>
                  <div class="text-xs text-gray-500">{{ option.item_code }}</div>
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="flex items-baseline gap-2">
                  <p class="text-base text-gray-800">{{ option.description }}</p>
                  <div class="text-xs text-gray-500">{{ option.item_code }}</div>
                </div>
              </template>
              <template slot="no-options">
                type to search item codes...
              </template>
            </v-select>
          </div>
          <div>
            <label for="free_qty">Free Qty</label>
            <input
              id="free_qty"
              type="number"
              class="mt-1 py-2 px-2 rounded w-full border"
              v-model.number="form.free_item_qty"
            />
          </div>
          <div>
            <label for="total_qty">Total Qty</label>
            <input
              id="total_qty"
              :disabled="form.unlimited"
              type="number"
              class="mt-1 py-2 px-2 rounded border w-full"
              v-model.number="form.total_qty"
            />
          </div>
          <div class="pb-2">
            <label>
              <input v-model="form.unlimited" @input="form.total_qty = null" name="criteria" value="one_order_per_customer" type="checkbox" /> Unlimited
            </label>
          </div>
          <div>
            <label for="total_qty">UOM</label>
            <select class="py-2 px-2 rounded mt-1 w-full border" v-model="form.free_item_unit" >
              <option v-for="unit in itemCodeUnits" :value="unit.key">{{ unit.label }}</option>
            </select>
          </div>
        </div>
      </div>
      <div>
        <div class="mt-5">
          <button :disabled="!canAddAction" class="rounded bg-primary-500 text-white p-3 whitespace-nowrap disabled:opacity-50" @click.prevent="addItem"><span>+</span> Add & Continue</button>
          <button :disabled="!canAddAction" class="rounded bg-blue-500 text-white p-3 whitespace-nowrap disabled:opacity-50" @click.prevent="addItemAndClose"><span>+</span> Add & Close</button>
          <button class="rounded bg-gray-400 text-white p-3 whitespace-nowrap disabled:opacity-50" @click.prevent="reset">Reset</button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from "../../../../Shared/Modal.vue";
import vSelect from 'vue-select'
import {debounce, mapValues} from "lodash";

export default {
  name: 'AddFreeItemModal',
  components: {Modal, vSelect},

  props: {
    value: Object,
    applicableType: {
      type: String,
      default: 'every_order',
    },
    rules: {
      type: Array,
      default: () => []
    },
  },

  data() {
    return {
      error: null,
      show: false,
      itemCodeUnits: [],
      selectableItems: [],
      form: {
        free_item: null,
        free_item_qty: null,
        free_item_unit: null,
        total_qty: null,
        unlimited: false,
      }
    }
  },

  methods: {
    open() {
      this.show = true
    },
    close() {
      this.show = false
      this.reset()
    },
    reset() {
      this.form = mapValues(this.form, () => null)
      this.error = null
    },
    reduceOption(option) {
      return {
        item_code: option.item_code,
        desc: option.description
      }
    },
    reloadItemUnits() {
      let selectedOption = this.form.free_item.item_code;
      if(selectedOption) {
        this.$http.get(this.route('ajax.item_units', {item_code: selectedOption})).then(response => {
          this.itemCodeUnits = response.data
        })
      }
    },
    searchItemCodes(val, loading) {
      this.getSearch(loading, val, this, this.route('ajax.items_list_search', {search:val}))
    },

    getSearch: debounce((loading, val, vm, url) => {
      if (val) {
        loading(true)
        vm.$http.get(url)
          .then(response => {
            loading(false)
            vm.selectableItems = response.data
          })
          .catch(() => loading(false))

      }
    }, 250),

    add() {
      let itemExists = this.rules.some(rule => rule.free_item.item_code === this.form.free_item.item_code);
      if (itemExists) {
        this.error = this.form.free_item.item_code+' already exist.'
      } else {
        this.$emit('add', this.form)
        this.reset()
      }
    },
    addItem() {
      this.add()
    },
    addItemAndClose() {
      this.add()
      if(!this.error) {
        this.close()
      }
    },
  },

  computed: {
    canAddAction() {
      let action = this.form
      let valid = false;
      if (action.free_item && action.free_item_qty && action.free_item_unit) {
        valid = true
      }
      if (!action.unlimited && !action.total_qty) {
        valid = false
      }
      return valid
    }
  }
}
</script>
